import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Soluciones',
    href: '#soluciones'
  }, {
    label: 'Seguridad',
    href: '#seguridad'
  }, {
    label: 'Casos de uso',
    href: '#casos-uso'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/80 backdrop-blur-lg border-b border-teal-500/10' : 'bg-transparent'}`} data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-111">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-112">
            <a href="#" className="flex items-center space-x-1 group" data-id="element-113">
              <span className="text-2xl font-display font-bold text-white" data-id="element-114">
                tru
              </span>
              <span className="text-2xl font-display font-bold text-teal-500" data-id="element-115">
                id
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500 group-hover:scale-125 transition-transform" data-id="element-116"></span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-117">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-gray-300 hover:text-teal-500 transition-colors text-sm font-medium" data-id="element-118">
                {link.label}
              </a>)}
            <button className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium transition-colors" data-id="element-119">
              Comenzar
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-120">
            {isMobileMenuOpen ? <X size={24} data-id="element-121" /> : <Menu size={24} data-id="element-122" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden bg-navy-800 border-t border-teal-500/10" data-id="element-123">
            <div className="px-4 py-6 space-y-4" data-id="element-124">
              {navLinks.map(link => <a key={link.label} href={link.href} className="block text-gray-300 hover:text-teal-500 transition-colors font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-125">
                  {link.label}
                </a>)}
              <button className="w-full bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-126">
                Comenzar
              </button>
            </div>
          </div>}
      </div>
    </nav>;
}